import React, { FC, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

import { ApplicationState } from "../store";
import { signinRedirect, signinRedirectWithCallbackArgs } from "src/oidcClient/userService";
import LoadingScreen from "./Common/Navigation/LoadingScreen";
import queryString from "query-string";
import { SessionStorageConstants } from "src/Core/Common/Constants";

const Login: FC = () => {
    const location: any = useLocation();
    const { user, isLoadingUser } = useSelector((state: ApplicationState) => state.userAuth);

    useEffect(() => {
        if (location?.search) {
            const params: any = queryString.parse(location.search);
            if (params.isSignInDialog) {
                sessionStorage.setItem(SessionStorageConstants.IS_SIGN_IN_DIALOG, "true");
            }
        }
        if (location && location.state && location.state?.from
            && location.state?.from?.pathname != "/"
        ) {
            signinRedirectWithCallbackArgs(
                location.state.from.pathname + (location.state.from.search ? location.state.from.search : "")
            );
        } else {
            if (!isLoadingUser && !user) {
                signinRedirect();
            }
        }
    }, []);

    if (!user) {
        if (isLoadingUser) {
            return <LoadingScreen />;
        }
        return <></>;
    }

    return <Navigate to="/" />;
};

export default Login;
